<template>
  <div>
    <div class="comond_btn">
      <el-button  @click="handleEdit(0, null)" >创建账号</el-button>
    </div>
    <template>
      <el-table
        :data="list"
        style="width: 100%">
        <!-- <el-table-column
          label="企业形象"
          width="">
          <template slot-scope="scope">
              <img :src="scope.row.headPortraitUrl" alt="" style="width:40px;height:40px;">
          </template>
        </el-table-column> -->
        <el-table-column
          prop="loginName"
          label="登录名"
          width="">
        </el-table-column>
        <el-table-column
          prop="createBy"
          label="创建人">
        </el-table-column>
        <el-table-column
          label="创建时间">
           <template slot-scope="scope">
             <div>{{ formatime(scope.row.createDate) }}</div>
           </template>
        </el-table-column>
        <el-table-column
          prop="updateBy"
          label="更新人">
        </el-table-column>
        <el-table-column
          label="更新时间">
          <template slot-scope="scope">
             <div>{{ formatime(scope.row.updateDate) }}</div>
           </template>
        </el-table-column>
        <el-table-column
          prop="roleName"
          label="角色">
        </el-table-column>
         <el-table-column
          prop="companyName"
          label="公司">
        </el-table-column>
        <el-table-column
          prop="staffName"
          label="员工">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
          <template slot-scope="scope">
              <el-button
              size="mini"
              :type="scope.row.status === 1?'success':'info'"
              @click="handleChangeStatus(scope.$index, scope.row)">
                <div v-if="scope.row.status === 1">有效</div>
                <div v-if="scope.row.status === 2">删除</div>
                <div v-if="scope.row.status === 3">禁用</div>
              </el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="操作选项">
           <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(1, scope.row)">编辑</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </template>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="centerDialogVisible"
        width="30%"
        center>
        <el-form :model="form">

          <el-form-item label="账号" :label-width="formLabelWidth">
            <el-input v-model="form.loginName" :disabled='isdisabled'></el-input>
          </el-form-item>

           <el-form-item label="密码" :label-width="formLabelWidth">
            <el-input v-model="form.pwd"></el-input>
          </el-form-item>

          <el-form-item label="关联公司" :label-width="formLabelWidth">
            <el-select v-model="form.companyId" placeholder="请选择" @change="handleChange" :disabled='isdisabled' >
              <el-option
                v-for="item in companyList"
                :key="item.key"
                :label="item.chineseName?item.chineseName:item.englishName"
                :value="item.id">
                <span style="float: left">{{ item.chineseName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.englishName }}</span>
              </el-option>
            </el-select>
          </el-form-item>

           <el-form-item label="公司下员工" :label-width="formLabelWidth">
            <el-select v-model="form.staffId" placeholder="请选择" :disabled='isdisabled'>
              <el-option
                v-for="item in contactList"
                :key="item.key"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

           <el-form-item label="角色" :label-width="formLabelWidth">
            <el-select v-model="form.roleId" placeholder="请选择" :disabled='isdisabled'>
              <el-option
                v-for="item in roleList"
                :key="item.key"
                :label="item.description"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 多角色 -->
          <!-- <el-form-item
            v-for="(n, index) in roles"
            :label="n.label + parseInt(index+1)"
            :key="n.id"
            :prop="'roles.' + index + '.value'"
            :label-width="formLabelWidth"
          >
          <el-col :span="8">
            <el-select v-model="n.key" filterable clearable placeholder="请选择">
              <el-option
                v-for="item in roleList"
                :key="item.key"
                :label="item.description"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-button @click.prevent="removeDom(n)" type="danger">删除</el-button>
          </el-col>
          </el-form-item>
          <el-form-item style="text-align:right;">
            <el-button @click="addDom()">新增参数</el-button>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handlesuccess(sts)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { queryall, findAll, addAccountUser, queryByCompanyId, queryrole, updateAccountStatus, updateAccountPwd, contactfindAll } from '../../api'
import utils from '../../../public/utils'
import qs from 'qs'
export default {
  data () {
    return {
      list: [],
      centerDialogVisible: false,
      form: { //  新增初始化form
        loginName: '', //  登录账号
        pwd: '', //  密码
        companyId: '', //  公司ID
        staffId: '', //  公司员工ID
        roleId: '', //  角色ID
      },
      // roles: [ //  多角色下有效
      //   {
      //     key: '',
      //     value: '',
      //     label: '角色'
      //   }
      // ],
      formLabelWidth: '120px',
      sts: 0, //  0 添加, 1 编辑
      companyList: [], //  公司列表
      contactList: [], //  联系人列表
      roleList: [], //  角色列表
      statystype: '', //  角色状态操作按钮颜色
      statyslabel: '',  //  角色状态操作按钮文字
      title: '', //  添加窗口标题
      isdisabled: false,
      rowId: ''
    }
  },
  methods: {
    handleEdit (ind, row) { //  编辑或者新增
      this.centerDialogVisible = true
      console.log(ind, row)
      if (ind === 1) {
        this.title = '编辑账号'
        this.rowId = row.id
        this.form = row
        this.sts = 1
        this.isdisabled = true //  编辑状态下其他组件不可见
      } else {
        this.title = '创建账号'
        this.form = {}
        this.sts = 0
        this.isdisabled = false
        this.getfindAll()
        this.getqueryrole()
      }
    },
    handlesuccess (sts) { //  提交修改信息
      if (sts === 0) {
        let para = new URLSearchParams()
        para.append('loginName', this.form.loginName)
        para.append('pwd', this.form.pwd)
        para.append('companyId', this.form.companyId)
        para.append('staffId', this.form.staffId)
        para.append('roleId', this.form.roleId)
        addAccountUser(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getqueryall()
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      } else {
        let para = new URLSearchParams()
        para.append('accountId', this.rowId)
        para.append('pwd', this.form.pwd)
        updateAccountPwd(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getqueryall()
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      }
    },
    handleChangeStatus (ind, row) { //  禁用/启用
      console.log(row)
      let status = 1
      if (row.status === 1) {
        status = 3
      } else {
        status = 1
      }
      this.$confirm('该操作将更改角色状态, 是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then( () => {
        let para = new URLSearchParams()
        para.append('accountId', row.id)
        para.append('status', status)
        updateAccountStatus(para).then(data => {
          console.log(data)
          if (data.code === 10000) {
            this.$message({
              type: 'success',
              message: data.msg
            })
            this.getqueryall()
          } else {
            this.$message({
              type: 'error',
              message: data.msg
            })
          }
        })
      })
      
    },
    getqueryall () { //  查询全部账号
      let params = qs.stringify({
        status: null
      })
      queryall(params).then(data => {
        console.log(data)
        this.list = data.data
      })
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
    getfindAll () { //  查询全部公司
      let para = {
        status: 1,
        typeId: null
      }
      findAll(para).then(data => {
        console.log(data)
        this.companyList = data.data.data
      })
    },
    getqueryByCompanyId (id) { //  根据公司id查询联系人信息
      let para = {
        companyId: id
      }
      contactfindAll(para).then(data => {
        console.log(data)
        this.contactList = data.data.data
      })
    },
    handleChange (value, label) { //  选择公司
      console.log(value, label)
      this.getqueryByCompanyId(value)
    },
    getqueryrole () { //  角色查询
      let params = qs.stringify({
        isValid: true
      })
      queryrole(params).then(data => {
        console.log(data)
        this.roleList = data.data
      })
    },
    /**
     * 多角色删除与添加
     */
    // removeDom (item) { //  删除元素
    //   let dom = this.roles
    //   if (dom.length <= 1) {
    //     this.$message.error('至少一个参数')
    //   } else {
    //     var index = dom.indexOf(item)
    //     if (index !== -1) {
    //       dom.splice(index, 1)
    //     }
    //   }
    // },
    // addDom () { //  增加参数
    //   this.roles.push({
    //     key: '',
    //     value: '',
    //     label: '角色'
    //   })
    // },
  },
  mounted () {
    this.getqueryall()
  }
}
</script>
<style lang="stylus" scoped>
.comond_btn
  display flex
  justify-content flex-end
  margin-bottom 30px
  button
    background-color #0a3d5f
    color #fff
</style>
